module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/up-down-4d0b7f9c23820848a06d646d9a1f5e73.svg";